<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="12">
          <div style="font-size: 20px; font-weight: bold; color: #4b92ff">
            {{ tabInfo.name }}
          </div>
          <div style="display: flex; align-items: baseline; margin-top: 10px">
            <span style="font-weight: 600"
              >{{ tabInfo.type }} <span v-show="tabInfo.description">•</span>
            </span>
            <span :title="tabInfo.description" class="tabInfo-des"
              >{{ tabInfo.description }}
            </span>
          </div>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 14px">{{ $t('message.title.rev') }}: </span>
          <el-select
            v-model="change_value"
            size="mini"
            style="width: 53%; overflow: hidden; position: relative; top: 10px"
            @change="changeInfoClick"
          >
            <el-option
              v-for="item in changeInfo"
              :key="item.value"
              :label="item.text"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-dropdown
            placement="bottom"
            style="margin-left: 10px"
            @visible-change="checkDelPriv"
          >
            <el-button size="mini">
              {{ $t('message.button.actions')
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="creatDijingItem"
                v-show="getCondition()"
                >{{ '增加虚拟子件' }}</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="creatDijingItemForSingleForm"
                v-show="getConditionSubClass()"
                >{{ '单表工件增加虚拟子件' }}</el-dropdown-item
              >

              <!-- @click.native="creatNew = true" :disabled="noChange" -->
              <el-dropdown-item @click.native="createNewChange">{{
                $t('message.button.createChange')
              }}</el-dropdown-item>

              <el-dropdown-item
                @click.native="creatNews = true"
                :disabled="noChanges"
                >{{ $t('message.button.createItemQuality') }}</el-dropdown-item
              >

              <el-dropdown-item
                v-if="getReleaseSystemCode"
                @click.native="docRelease"
                >{{ '变更发布' }}</el-dropdown-item
              >

              <el-dropdown-item @click.native="saveAs = true">{{
                $t('message.button.saveAs')
              }}</el-dropdown-item>
              <!-- <el-dropdown-item @click.native = "cc">创建变更</el-dropdown-item> -->
              <el-dropdown-item @click.native="addFavorite">{{
                $t('message.button.bookmark')
              }}</el-dropdown-item>
              <el-dropdown-item @click.native="removeFavorite">{{
                $t('message.button.cancelBookmark')
              }}</el-dropdown-item>
              <el-dropdown-item
                :disabled="!deletePriv"
                @click.native="deleteItem"
                >{{ $t('message.button.delete') }}</el-dropdown-item
              >

              <el-dropdown-item
                v-for="item in upgradeList"
                :disabled="!item.hasButton"
                :key="item.index"
                @click.native="upgradeSequenceRevMfr(item.buttonType)"
              >
                {{ item.name }}
              </el-dropdown-item>

              <!-- <Action></Action> -->
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="4" style="font-size: 28px">
          {{ tabInfo.lifeCycle }}
        </el-col>
      </el-row>
    </el-card>

    <el-dialog
      v-if="saveAs"
      v-dialogDrag
      class="searchAddBomList"
      :title="$t('message.title.saveAs')"
      :visible.sync="saveAs"
      :close-on-click-modal="!saveAs"
    >
      <save-as-form
        :versionList="changeInfo"
        @close="cancelSaveAs"
      ></save-as-form>
    </el-dialog>

    <el-dialog
      v-if="creatNew"
      v-dialogDrag
      class="searchAddBomList"
      :title="$t('message.title.add')"
      :visible.sync="creatNew"
      :close-on-click-modal="!creatNew"
    >
      <Create
        :baseClass="baseClass_"
        @addToList="addToChangeList"
        @closeCreateNew="closeCreateNew"
      ></Create>
    </el-dialog>

    <el-dialog
      v-if="creatNews"
      v-dialogDrag
      class="searchAddBomList"
      :title="$t('message.title.add')"
      :visible.sync="creatNews"
      :close-on-click-modal="!creatNews"
    >
      <Create
        :baseClass="baseClass_quality"
        @addToList="addToChangeLists"
        @closeCreateNew="closeCreateNews"
      >
      </Create>
    </el-dialog>
    <!-- tab切换 -->
    <div class="content">
      <div class="content-title">
        <div
          @click="tabClick(item, index)"
          class="content-item"
          :class="{ active: index == num }"
          v-for="(item, index) in tabList"
          :key="index"
        >
          <div style="display: flex">
            <div>
              <div v-if="showMultiBOM(item)">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{ bomsName }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item2, index2) in tabBoms"
                      @click.native="tabBomsClick(item2, index)"
                      :key="index2"
                      >{{ item2.name }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-else>
                {{ item.name }}
              </div>
            </div>
            <div
              :style="{ visibility: item.isResult ? 'visible' : 'hidden' }"
              style="margin-left: 3px; font-size: 22px"
            >
              *
            </div>
          </div>
        </div>
      </div>
      <div style="height: 6px; background: rgb(235, 235, 235)"></div>

      <div class="route-content" :key="changeInfo.length">
        <keep-alive>
          <router-view
            v-if="$route.meta.keepAlive"
            :changeValue="change_to_child"
            :relUrl="relUrl"
            :isCreate="createChange"
            :type="item"
            @routeClick="reload"
            :changeRevInfo="changeInfo"
          />
        </keep-alive>

        <router-view
          v-if="!$route.meta.keepAlive"
          :changeValue="change_to_child"
          :relUrl="relUrl"
          :isCreate="createChange"
          :type="item"
          @routeClick="reload"
          @refreshTab="refreshTab"
          :changeRevInfo="changeInfo"
        />
      </div>

      <el-dialog
        v-if="setDocRelease"
        v-dialogDrag
        class="searchAddBomList"
        :title="$t('message.title.add')"
        :visible.sync="setDocRelease"
        :close-on-click-modal="!setDocRelease"
        @close="dialogClose"
      >
        <!-- <Create :baseClass="baseClass_" @addToList="addToChangeList" @closeCreateNew="closeCreateNew">  -->
        <UplaodDoc
          :changeInfo="upDocChange"
          @getStatusChange="getStatusChange"
          @dialogClose="dialogClose"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Create from '@/components/common/Create.vue'
import SaveAsForm from '../common/saveAsForm.vue'
import { itemTabList } from '@/utils/publicstate'
import { getTabIndex } from '@/utils/index.js'
import {
  MULTI_BOM_LIST,
  ITEM_FOR_MEDLINKET_ATTACHMENT,
  CHANGE_FOR_MEDLINKET,
} from '@/utils/constants.js'
import Action from './action.vue'
import { dialogDrag } from '@/utils/directive'

import UplaodDoc from './uploadDoc.vue'

import Vue from 'vue'
Vue.directive('dialogDrag', dialogDrag)

export default {
  name: 'item',
  data() {
    return {
      bomsName: '',
      bomNumber: 0,

      upgradeList: [],

      generateCodeNumberButton: false,
      upgradeSequenceButton: false,
      upgradeRevButton: false,
      changeManufactureButton: false,
      updateCodeNumberButton: false,
      generateCodeNumberButtonName: '',
      upgradeSequenceButtonName: '',
      upgradeRevButtonName: '',
      changeManufactureButtonName: '',
      updateCodeNumberButtonName: '',
      // routeLink : Boolean,
      relUrl: 'items',

      createClassId: '',
      base: '',
      creatNew: false,
      creatNews: false,
      createChange: false,
      saveAs: false,
      item: 'item',
      noChange: false,
      noChanges: false,
      changeInfo: [], //版本信息
      changeInfo_All: [], //change的所有信息
      change_value: '0', //change选中的信息
      change_to_child: '', //向子组件传送change信息

      title_number: '',
      title_2: '',
      title_3: '',
      title_4: '',
      page_one: [],
      tabList: [],
      tabBoms: [],

      tabInfo: {},
      loading: true,
      deletePriv: false,
      baseClass_: '104',
      baseClass_quality: '401',
      tabIdLists: [],
      setDocRelease: false,
      upDocChange: {},
      objectId: {},
      unReleasedChangeNumber: '',
    }
  },
  components: {
    Create,
    SaveAsForm,
    Action,
    UplaodDoc,
  },
  mounted() {},
  methods: {
    getStatusChange(e) {
      // this.setChangeRelease()
      //   .then(res => {
      //     const { object } = res.data;
      //     const { id, classId, subclassId: subClassId } = object;
      //     this.upDocChange = {
      //       changeId: id,
      //       changeClassId: classId,
      //       changeSubClassId: subClassId
      //     }
      //     return this.setSaveTable(object);
      //   }).then(res => {

      //   })

      const { changeId: id } = e
      this.statusChange(id).then((res) => {
        this.setDocRelease = false
        this.logoInfo()
      })
    },
    dialogClose() {
      this.setDocRelease = false
      // this.logoInfo();
    },

    setSaveTable(object) {
      const { id, classId, subclassId: subClassId } = object

      const obj = {
        tableId: 5,
        changeObjId: {
          id,
          classId,
          subClassId,
          version: this.version,
        },
        insertAffectedItem: [
          { changeId: id, item: this.objectId.id, 1005005: '1', 1005007: 248 },
        ],
        inheritAttachment: true,
      }
      return axios.post('/pmdm/changes/saveTable', obj)
    },

    createNewChange() {
      if (this.unReleasedChangeNumber) {
        this.$message.error(
          `当前物料已存在于待定变更 ${this.unReleasedChangeNumber}`
        )
        return
      }
      this.creatNew = true
    },
    docRelease() {
      if (this.unReleasedChangeNumber) {
        this.$message.error(
          `当前物料已存在于待定变更 ${this.unReleasedChangeNumber}`
        )
        return
      }

      if (this.changeInfo.length == 1) {
        this.setChangeRelease()
          .then((res) => {
            const { object } = res.data
            return this.setSaveTable(object)
          })
          .then((res) => {
            const { id } = res.data.object.changeObjId
            return this.statusChange(id)
          })
          .then((res) => {
            this.logoInfo()
          })
        return
      }

      this.setDocRelease = true
    },
    setChangeRelease() {
      const obj = { ...CHANGE_FOR_MEDLINKET }
      return axios.post(`/pmdm/changes/saveChangeP1P2P3`, obj)
    },
    statusChange(id) {
      const obj = {
        id,
        ...ITEM_FOR_MEDLINKET_ATTACHMENT,
      }
      return axios.post('/pmdm/changes/statusChange', obj)
    },

    showMultiBOM(item) {
      return MULTI_BOM_LIST.includes(item.id) && this.tabBoms.length > 1
    },

    clickBtn() {},
    getCondition() {
      // this.tabInfo.name
      const tenantName = window.sessionStorage.getItem('tenantName')
      if (!this.tabInfo?.name) {
        return
      }
      const prevWith2 = this.tabInfo?.name.substr(0, 2)
      const prevWith4 = this.tabInfo?.name.substr(0, 4)
      const hasDijing = tenantName.indexOf('帝京半导体') != -1
      return hasDijing && prevWith2 == '20' && prevWith4 != '2001'
    },
    getConditionSubClass() {
      const tenantName = window.sessionStorage.getItem('tenantName')
      const hasDijing = tenantName.indexOf('帝京半导体') != -1
      return hasDijing && this.objectId.subClassId == 9020245
    },

    creatDijingItem() {
      axios
        .get('/pmdm/items/createItemAndBomDijing?itemId=' + this.objectId.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
          }
        })
    },
    creatDijingItemForSingleForm() {
      axios
        .get(
          '/pmdm/items/createItem2001AndBomDijing?itemId=' + this.objectId.id
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
          }
        })
    },
    tabBomsClick(obj, index) {
      if (this.bomNumber !== -1) {
        this.tabList[this.bomNumber] = obj
      }
      this.bomsName = obj.name
      this.tabClick(obj, index)
    },

    generateCodeNumber(type) {
      var change_info = this.$store.state.change_info
      var generateCodeNumber = {
        //post更改的值
        ...this.objectId,
        changeId: change_info.changeId,
        changeClassId: change_info.changeClassId,
        changeSubClassId: change_info.changeSubClassId,
        buttonType: type,
      }
      axios
        .get(
          `/pmdm/items/itemUpgradeOperations${this.params(generateCodeNumber)}`
        )
        // .post("/pmdm/items/itemUpgradeOperations", generateCodeNumber)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.replaceTabsName(res.data.object.item.itemNumber)
            this.logoInfo()
          }
        })
        .catch(function (error) {})
    },
    upgradeSequenceRevMfr(type) {
      this.$confirm(
        '请注意更新对应新物料的描述信息',
        this.$t('message.tips.tip'),
        {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          var change_info = this.$store.state.change_info
          var upgradeSequence = {
            //post更改的值
            ...this.objectId,
            ...change_info,
            buttonType: type,
          }
          axios
            .get(
              `/pmdm/items/itemUpgradeOperations${this.params(upgradeSequence)}`
            )
            // .post("/pmdm/items/itemUpgradeOperations", generateCodeNumber)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: 'success',
                })
                const {
                  id,
                  classId,
                  subclassId,
                  itemNumber: title,
                } = res.data.object.item
                const obj = { id, classId, subclassId, title }

                this.getLink(obj)
                this.$store.commit('setPageRefresh')
              }
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消更新',
          })
        })
    },

    cancelSaveAs() {
      this.saveAs = false
    },
    closeCreateNew() {
      this.creatNew = false
    },
    closeCreateNews() {
      this.creatNews = false
    },

    addToChangeList(e) {
      this.creatNew = false
      const insertAffectedItem = e.map((i) => {
        return { changeId: i.id, item: this.objectId.id }
      })
      var obj = {
        //post更改的值
        tableId: 5,
        changeObjId: {
          id: e[0].itemId,
          classId: e[0].itemClassId,
          subClassId: e[0].itemSubClassId,
          version: this.version,
        },
        insertAffectedItem,
        inheritAttachment: true,
      }

      const tenantName = window.sessionStorage.systemName
      tenantName.indexOf('Thondar') != -1 && (obj.isAdd = '1')

      axios
        .post('/pmdm/changes/saveTable', obj)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })

            const obj = {
              id: e[0].itemId,
              classId: e[0].itemClass,
              subClassId: e[0].itemSubClassId,
              name: e[0].itemNumber,
            }
            this.getLink(obj)
          }
        })
        .catch(function (error) {})
      this.creatNew = false
    },

    addToChangeLists(e) {
      this.creatNews = false
      let relationshipMapVo = {}
      let arr = e.map((i) => {
        return {
          ctrObjid: this.objectId.id,
          ctrObjtype: this.objectId.classId,
          effObjid: i.id,
          effObjtype: i.itemClass,
          name: i.itemNumber,
          relType: '4',
        }
      })
      relationshipMapVo.relationshipVoList = arr
      axios
        .post('/pmdm/relationship/saveRelationship', relationshipMapVo)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            const obj = {
              id: e[0].itemId,
              classId: e[0].itemClass,
              subClassId: e[0].itemSubClassId,
              name: e[0].itemNumber,
            }
            this.getLink(obj)
            this.$store.commit('setPageRefresh')
          }
        })
        .catch(function (error) {})
      this.creatNews = false
    },

    deleteItem() {
      this.$confirm(
        this.$t('message.confirm.deleteObject'),
        this.$t('message.tips.tip'),
        {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          let obj = {
            //subClassId: this.$store.state.subClassId_,
            ...this.objectId,
            //id: this.$store.state.objId_,
            //classId: this.$store.state.classId_,
          }
          axios
            .get(`/pmdm/items/deleteItemP1${this.params(obj)}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message)
                this.$emit('deletePage', this.tabInfo.name)
              } else {
                this.$message({
                  type: 'info',
                  message: this.$t('message.error.delete'),
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('message.tips.deleteCancel'),
          })
        })
    },
    removeFavorite() {
      this.removeFavoriteInCommon({
        baseClassId: this.Constants.itemBaseClassId,
        number: this.tabInfo.name,
        ...this.objectId,
        //id: this.$store.state.objId_,
      })
    },
    refreshTab() {
      this.$getTabsIsUsedResult(this.tabIdLists).then((res) => {
        this.tabList.map((item) => {
          const isTrue = res.includes(item.id)
          this.$set(item, 'isResult', isTrue)
        })
      })
    },
    reload(e) {
      if (e == undefined) {
        this.logoInfo()
        return
      }
      const obj = {
        id: e.itemId,
        classId: e.itemClassId,
        subClassId: e.itemSubClassId,
        title: e[0],
      }
      this.getLink(obj)
    },
    checkDelPriv(e) {
      let isSupAdmin = this.$store.state.isSuperAdmin
      if (e) {
        const arr = JSON.parse(sessionStorage.getItem('userContext')).privs
        const privsArr = arr.map((i) => {
          return i.type
        })
        if (privsArr.indexOf(25) != -1 || isSupAdmin) {
          this.deletePriv = true
        }
      }
    },
    addFavorite() {
      let description_ = ''
      if (this.tabInfo.description) {
        description_ = ':' + this.tabInfo.description
      }
      this.addFavoriteInCommon({
        baseClassId: this.Constants.itemBaseClassId,
        number: this.tabInfo.name + description_,
        ...this.objectId,
        //id: this.$store.state.objId_,
      })
    },

    changeInfoClick() {
      var index = this.change_value
      var commit_change = {}

      for (var i = 0; i < this.changeInfo_All.changes.length; i++) {
        if (this.changeInfo_All.changes[i].id == index) {
          commit_change = this.changeInfo_All.changes[i]
        }
      }
      var obj_ = {}
      obj_.changeId = commit_change.id
      obj_.changeClassId = commit_change.classId
      obj_.changeSubClassId = commit_change.subClassId

      //var change_info = this.$store.state.change_info;

      this.$store.commit('setChangeInfo2', obj_)

      this.loadPageOne()

      this.change_to_child = obj_
      this.loadCodeNumber()
      this.$getTabsIsUsedResult(this.tabIdLists).then((res) => {
        this.tabList.map((item) => {
          // item.isResult = res.indexOf(item.id) != -1 ? true:false;
          const isTrue = res.includes(item.id)
          this.$set(item, 'isResult', isTrue)
        })
      })
    },
    tabClick(res, index) {
      // this.num = index;
      let obj = itemTabList.find((i) => {
        return i.id == res.id
      })

      if (obj?.tableId) {
        this.$store.commit('setBomsTableId', obj.tableId)
      }
      this.$router.push({
        path: obj.path,
        query: {
          ...this.objectId,
          changeInfoNum: JSON.stringify(this.changeInfo),
        },
      })
      this.$store.commit('setTabIndex', { ...this.objectId, index })
    },
    getTab() {
      this.$http
        .get('/pmdm/admin/getTab/' + this.objectId.subClassId)
        .then((res) => {
          this.tabList = res.data.object.tabs.map((i) => {
            i.path = itemTabList.find((j) => j.id == i.id).path
            return i
          })

          const tabIndex = getTabIndex({ ...this.objectId })?.index || 0
          this.tabClick(
            itemTabList.find((j) => j.id == this.tabList[tabIndex].id),
            tabIndex
          )

          this.bomNumber = this.tabList.findIndex((item) => item.id == 1010103)
          this.tabBoms = res.data.object.boms
          let m = this.tabList.map((i) => i.id)

          this.tabList.map((item) => {
            if (item.id == 1010103) {
              this.bomsName = item.name
            }
          })
          if (!m.includes(1010102)) {
            this.noChange = true
          }

          if (!m.includes(1010108)) {
            this.noChanges = true
          }

          this.tabIdLists = Array.from(this.tabList, ({ id }) => id)
          // this.getTabsIsUsedResult();
          this.$getTabsIsUsedResult(this.tabIdLists).then((res) => {
            this.tabList.map((item) => {
              // item.isResult = res.indexOf(item.id) != -1 ? true:false;
              const isTrue = res.includes(item.id)
              this.$set(item, 'isResult', isTrue)
            })
          })
        })
    },
    async logoInfo() {
      var obj_get = {
        //获取change
        itemId: this.objectId.id,
        itemSubClassId: this.objectId.subClassId,
      }
      const getChangeIdUrl = `/pmdm/items/getRevInfo${this.params(obj_get)}`
      const { data } = await axios.get(getChangeIdUrl)

      if (data.code == 200 && data.object.revInfo != null) {
        const revInfo = data.object.revInfo
        const { changeNumbers, released } = revInfo
        this.changeInfo = this.getChangeSelect(revInfo)
        this.change_value = revInfo.defaultRev.id
        this.changeInfo_All = revInfo
        this.$store.commit('setChangeInfo', revInfo.defaultRev)
        const {
          id: changeId,
          classId: changeClassId,
          subClassId: changeSubClassId,
        } = revInfo.defaultRev
        this.change_to_child = { changeId, changeClassId, changeSubClassId }
        this.unReleasedChangeNumber =
          changeNumbers.find((i, e) => {
            return i && !released[e]
          }) || ''
        console.log('unReleasedChangeNumber', this.unReleasedChangeNumber)
      }

      this.loadCodeNumber()
      this.loadPageOne()
      this.getTab()
    },

    getPageInfo(obj, cells) {
      let keys = Object.keys(obj)
      let newObj = {}
      Object.values(obj).map((i, e) => {
        let val = cells.find((j) => j.columnId == i)?.val || ''
        Object.assign(newObj, { [keys[e]]: val })
      })
      return newObj
    },

    loadPageOne() {
      var obj_get = {
        ...this.objectId,
        ...this.$store.state.change_info,
        tableId: this.$store.state.tableId_1,
      }

      axios.get(`/pmdm/items/loadTable${this.params(obj_get)}`).then((res) => {
        const { columnInfo, rows } = res.data.object.table

        const { ids, names, uiTypes } = columnInfo
        const cellList = rows[0].cells

        const infoList = ids.map((i, e) => {
          const uiType = uiTypes[e]
          const val = cellList[e].val
          return { id: i, title: names[e], uiType, val }
        })

        const arr = [
          { id: 1000001, title: 'name' },
          { id: 1000002, title: 'type' },
          { id: 1000003, title: 'description' },
          { id: 1000006, title: 'lifeCycle' },
        ]

        for (const i of arr) {
          const label = infoList.find((j) => i.id === j.id).val
          this.$set(this.tabInfo, i.title, label)
        }
        this.$store.commit('setTabInfo', this.tabInfo)

        //添加最近访问
        const obj = {
          baseClassId: this.Constants.itemBaseClassId,
          number: this.tabInfo.name,
          ...this.objectId,
        }
        this.addRecentVistInCommon(obj)
        this.updateFavoriteInCommon(obj)
      })
      // .catch((err)=>{

      //   this.objectDelConfirm('deletePage')
      // })
    },

    loadCodeNumber() {
      var change_info = this.$store.state.change_info
      let obj = {
        ...this.objectId,
        ...change_info,
      }
      axios
        .get(`/pmdm/items/getAttrNumButtons${this.params(obj)}`)
        .then((res) => {
          const { code, object = {} } = res.data
          if (code == 200) {
            if (JSON.stringify(object) != '{}') {
              const { attrNumButtons } = object
              this.upgradeList = attrNumButtons.filter((i) =>
                [2, 3, 4].includes(i.buttonType)
              )
            }
          }
        })
    },
  },
  computed: {
    stockQuery() {
      const systemName = window.sessionStorage.getItem('systemName')
      return systemName.indexOf('帝京') == -1
    },
    num() {
      return this.tabList.findIndex((i) => i.path == this.$route.path)
    },
    getReleaseSystemCode() {
      const { subClassId } = this.objectId
      const systemCode = window.sessionStorage.getItem('systemCode') || ''
      return (
        systemCode.indexOf('medlinket') !== -1 &&
        (subClassId == 20000028 || subClassId == 20000025)
      )
    },
  },

  created() {
    const { id, classId, subClassId } = this.$route.query
    const obj = { id, classId, subClassId }
    this.objectId = { id, classId, subClassId }
    this.$store.commit('setObjectId', obj)

    this.logoInfo()
  },
}
</script>

<style scoped scss>
.route-content {
  padding: 10px 15px;
  height: calc(100vh - 320px);
  overflow-y: scroll;
}

.content-title {
  height: 45px;
  display: flex;
  gap: 20px;
  padding-left: 20px;
  margin-top: 8px;

  .content-item {
    padding: 8px 15px;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }

    &.active {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }
  }
}

.tabInfo-des {
  margin-left: 5px;
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
</style>
